import { SortConfig, SortDirection } from "../constants/config/sort";

export function sortItems<T>(
  items: readonly T[],
  { key, accessor, direction = SortDirection.ASC }: SortConfig<T>,
): T[] {
  const factor = direction === SortDirection.ASC ? 1 : -1;

  const getValue = (item: T) =>
    accessor ? accessor(item) : key ? item[key] : item;

  return [...items].sort((a, b) => {
    const av = getValue(a);
    const bv = getValue(b);

    // push null / undefined to the end
    if (av == null && bv == null) return 0;
    if (av == null) return 1;
    if (bv == null) return -1;

    return (
      String(av).localeCompare(String(bv), undefined, {
        numeric: true,
        sensitivity: "base",
      }) * factor
    );
  });
}
